//
//
//
//
//
//
//

import Components from '@/components/dynamicComponent'

  export default {
    components: {
      Components
    },
    data() {
      return {
        error: null
      }
    },
    computed: {
      d () {
        const slug = this.$route.params.slug;
        console.log('getter projects _slug: ',slug)
        return this.$store.getters.projects[slug]
      }
    },
    async asyncData({
      params,
      error,
      store
    }) {
      try {
        await store.dispatch('getProjects', params.slug)
      } catch (e) {
        error({
          statusCode: e.statusCode,
          message: e.message
        })
      }
    },
  }

